import { ListViewFilters, SearchInput } from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import { useFilters } from 'hooks/useFilters';
import React, { useEffect, useState } from 'react';
import { debounceV2 } from 'utils/Debounce';
import StatusFilter from './StatusFilter';

const Filters = ({ structures }: { structures: SalaryStructure[] }) => {
  const [search, setSearch] = useState('');

  const { removeFilter, applyFilter } = useFilters({
    filtersMap: {
      search: 'search',
    },
  });

  const handleClearSearch = () => {
    setSearch('');
  };

  const debouncedSearch = debounceV2(async (searchText: string) => {
    applyFilter('search', searchText);
  }, 500);

  useEffect(() => {
    debouncedSearch(search);
    if (search === '') {
      removeFilter('search');
      return;
    }
  }, [search]);

  const handleSearchChange = ({ value }: { value?: string | undefined }) => {
    setSearch(value || '');
  };

  return (
    <ListViewFilters
      quickFilters={<StatusFilter structures={structures} />}
      actions={
        <SearchInput
          label=""
          accessibilityLabel="Search salary structure"
          name="salary-structure-search"
          value={search}
          placeholder="Search salary structure"
          onChange={handleSearchChange}
          onClearButtonClick={handleClearSearch}
        />
      }
    />
  );
};

export default Filters;
